import * as React from 'react';

import { StringMode } from '@comall-backend-builder/types';
import { VideoUpload } from '../../../components';

export class StringVideoPickerMode extends StringMode {
    /**
     * 获取展示组件
     */
    public getAvailableDisplayComponent(value: any, _displayInfo: any) {
        return (
            <video
                src={value}
                style={{ width: '100px', height: '100px' }}
                preload="metadata"
                controls
            ></video>
        );
    }

    /**
     * 获取输入组件
     */
    public getControlComponent(controlInfo: any) {
        let _controlInfo = Object.assign({}, controlInfo, {
            accept: 'video/mp4',
            uploadType: 'single',
            multiple: false,
        });
        return <VideoUpload {..._controlInfo} />;
    }
}
